import { render, staticRenderFns } from "./StudentPaperIssueActivity.vue?vue&type=template&id=7c4ca6c3"
import script from "./StudentPaperIssueActivity.vue?vue&type=script&lang=js"
export * from "./StudentPaperIssueActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports